const configs = {
  APP_ENV: process.env.REACT_APP_ENV,
  API_DOMAIN: process.env.REACT_APP_API_DOMAIN,
  AWS_DOMAIN: process.env.REACT_APP_AWS_DOMAIN,
  TINYMCE_API_KEY: process.env.REACT_APP_TINYMCE_API_KEY,
};

export default configs;
